@if (isGameNotesVisible) {
    <ms-game-notes class="game-notes-layout" [gameNotes]="gameNotes" />
}
<ms-event-info
    [event]="event"
    [showEventTimerInfoSection]="showEventTimerInfoSection"
    [showFixedFooterSection]="showFixedFooterSection"
    [mediaEnabled]="mediaEnabled"
    [disableBadges]="!!promotedFixtureIdsMap[event.id] && isMobilePhone">
    @if (promotedFixtureIdsMap[event.id]) {
        <ms-promotion-badge />
    }
</ms-event-info>

<div class="grid-event-info all-markets-link">
    <span class="title">{{ sitecore.eventGrid.AllMarketsLink | msInterpolate: { count: event.totalMarketsCount } }}</span>
    <ng-container *msShowInEpcot="{ showInEpcot: false }">
        <vn-icon class="icon-alignment" name="theme-right" size="11" />
    </ng-container>
    @if (gridConfig.gridEventDisplayVersion === 'V2') {
        <vn-icon class="icon-alignment" name="theme-right" size="12" />
    }
</div>
